import { useQuery } from '@tanstack/react-query';

import { getUser } from './request';
import type { User } from './request.type';

export const GET_USER = 'user';

export function useGetUser({ email }: { email?: string }) {
  return useQuery({
    queryKey: [GET_USER, { email }],
    queryFn: () => getUser({ email: email ?? '' }),
    // This is a temporary solution to change the label of the module claim "modules"
    select: (user: User) => ({
      ...user,
      claims: user.claims.map((claim) =>
        claim?.module?.id === 'modules'
          ? {
              ...claim,
              module: {
                ...claim.module,
                label: 'Creador de módulos',
              },
            }
          : claim,
      ),
    }),
    enabled: !!email,
  });
}
